
import { useState } from "react";
import { VisitActive, VisitPassive } from "../../../../assets/icons";
import { api } from "../../../../utils/api";
import { LoginHelper } from "../../../../utils/LoginHelper";

export default function Visit({ dayId, visit, onToggleVisitActive }) {
	const [isActive, setIsActive] = useState(visit.is_active);
	const [isLoading, setIsLoading] = useState(false);

	const toggle = () => {
		if (isLoading) return;
		setIsLoading(true);
		api.visitToggleVisitActive({
			token: LoginHelper.getToken(),
			start_datetime: visit.start_datetime,
			finish_datetime: visit.finish_datetime,
		}).then((res) => {
			setIsLoading(false);
			setIsActive(!isActive);
			onToggleVisitActive(dayId, visit.start_datetime, !isActive);
		}).catch((err) => {
			setIsLoading(false);
			console.log(err);
		});
	}

	return (
		<div className={`${isActive ? 'bg-[#CDE7FF]' : 'bg-[#EBEFF3]'} rounded-[10px] p-[10px] cursor-pointer`} onClick={() => toggle()}>
			<div></div>
			<div className="flex flex-row justify-center items-center">
				<div className="font-Vazir-400 text-[16px]">{visit.start_time}</div>
				<div className="px-[5px]">-</div>
				<div className="font-Vazir-400 text-[16px]">{visit.finish_time}</div>
			</div>
			<div className="spacer p-[5px]"></div>
			<div>
				{isActive ? (
					<div className="flex flex-row justify-between items-center bg-white h-[20px] rounded-[10px] px-[10px] py-[5px]">
						<div className="flex flex-row justify-center items-center w-[25px] h-[25px] rounded-[20px] bg-[#276AA6]">
							<VisitActive />
						</div>
						<div className="spacer p-[5px]"></div>
						<div className="font-Vazir-400 text-[12px] text-[#aaaaaa]">
							فعال
						</div>
					</div>
				) : (
					<div className="flex flex-row justify-between items-center bg-white h-[20px] rounded-[10px] px-[10px] py-[5px]">
						<div className="font-Vazir-400 text-[12px] text-[#aaaaaa]">
							غیرفعال
						</div>
						<div className="spacer p-[5px]"></div>
						<div className="flex flex-row justify-center items-center w-[25px] h-[25px] rounded-[20px] bg-[#969BA1]">
							<VisitPassive />
						</div>
					</div>
				)}
			</div>
			<div className="spacer p-[5px]"></div>
			<div>
				{visit.user_phone_number ? (
					<div className="font-Vazir-400 text-[12px] text-black text-center">{visit.user_phone_number}</div>
				) : (
					<></>
				)}
			</div>
		</div>
	)
}
